$(document).on('turbolinks:load', () => {
  const $propheticNewsHeaders = $('.prophetic_news_header')
  if ($propheticNewsHeaders.length === 0) return

  $propheticNewsHeaders.each((_idx, element) => {
    const $propheticNewsHeader = $(element)
    const $slider = $propheticNewsHeader.find('.slider')

    // Different slides height on IE11 fix.
    // We use "settle.flickity" event instead of "ready.flickity" because
    // the "ready" is fired when the slider is in inconsistent state,
    // for example, when the slides haven't received their final height.
    $slider.on('settle.flickity', () => {
      const $contents = $slider.find('.content_wrapper')
      const contentHeights = $contents
        .map((_idx, element) => $(element).outerHeight())
        .get() // convert the result into array

      const allContentsSameHeight = contentHeights.every(
        (el) => el === contentHeights[0]
      )

      // If all contents have same height then we don't need the fix.
      // Basically it means we are not on IE and everything should work nicely.
      if (allContentsSameHeight) return

      const maxHeight = Math.max.apply(null, contentHeights) // max of the array
      $contents.each((_idx, element) => {
        // Using "min-height" to allow a slide to grow in height when
        // collapsible text has been opened.
        $(element).css('min-height', maxHeight)
      })
    })
  })
})
